module.exports = __webpack_public_path__ + "static/img/03.8f30e84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/03.png
// module id = EWLt
// module chunks = 2